import { useState } from "react";

import dayjs from "@eisox/dayjs";
import type { DateFieldUnit, DateRange } from "@eisox/design-system";

import { PeriodField } from "~/components/period-field";
import { toDateRange, toDayRange, type DayRange } from "~/helpers/day-range.helper";

interface IncompleteSelection {
  selection: DateRange;
  valueKey: string;
}

interface DayRangePickerProps {
  value?: DayRange;
  onValueChange: (range: DayRange) => void;
  max: string;
  unit?: DateFieldUnit;
  className?: string;
}

const DayRangePicker: React.FC<DayRangePickerProps> = ({ value, onValueChange, max, unit, className }) => {
  const [incomplete, setIncomplete] = useState<IncompleteSelection>();
  const valueKey = value ? `${value.from}_${value.to}` : "";

  const handleValueChange = (selection: DateRange) => {
    const range = toDayRange(selection);
    const isComplete = range !== undefined && range.to <= max;
    setIncomplete(isComplete ? undefined : { selection, valueKey });
    if (isComplete) onValueChange(range);
  };

  return (
    <PeriodField
      value={incomplete?.valueKey === valueKey ? incomplete.selection : toDateRange(value)}
      onValueChange={handleValueChange}
      max={dayjs(max)}
      unit={unit}
      className={className}
    />
  );
};

DayRangePicker.displayName = "DayRangePicker";

export { DayRangePicker };
